import React from 'react'
import { ActivityGridOld, TagInput } from '../../../../../../components'
import { THEMES } from '../../../../../../utils/ui'
import { ENTITY_FUND, ENTITY_TYPE, formatEntity } from '../../../../../../utils/entity'

import { AttributesContainer, FlyoutBadge, HighLightsContainer } from '../components'
import { SectionTab } from '../../../../../../components/shared'
import HoldingGrid from '../../../../../../components/ownership/holding/grid/grid.container'
import { ContactGridOld } from '../../../../../../components/contact'
import FlyoutTitle from '../components/flyoutTitle/flyoutTitle.container'
import FlyoutBanner from '../components/banner/banner.component'
import Grid from '@material-ui/core/Grid'
import { FLYOUT_ENTITY_TYPES } from '../../../../../../utils'

const Fund = ({ classes, fund, targetId, hasDeal, isLoading, handleRedirect, ...props }) => {
  const entity = formatEntity(fund, ENTITY_FUND)

  return (
    isLoading
      ? null
      : (
        <div className='q4-fade-in target-detail--fund'>
          <FlyoutBanner
            title={(<FlyoutTitle title={entity.fund_name} />)}
            icon='q4i-fund-2pt'
            theme={THEMES.WHITE}
            badgeType='fund'
            data={entity}
            targetId={targetId}
            hasDeal={hasDeal}
            entityType={ENTITY_FUND}
            details={`${entity.type} | Style: ${entity.style} | Turnover: ${entity.turnover}`}
            handleClose={props.handleClose}
            handleTargetUtilAction={props.handleTargetUtilAction}
          />
          <div className='target-detail_overview'>
            <Grid container spacing={3}>
              <FlyoutBadge targetId={targetId} />
              <Grid item xs={6}>
                <Grid container spacing={3}>
                  <Grid item xs={12} className='grid-section'>
                    <AttributesContainer
                      entityType='fund'
                      className='card-attributes'
                      entityId={entity.factset_fund_id}
                      entity={entity}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <HighLightsContainer
                      entity={{
                        ...entity,
                        entityType: FLYOUT_ENTITY_TYPES.FUND
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <TagInput
                  theme={THEMES.LIGHT}
                  entityType={ENTITY_TYPE.FUND}
                  entityId={entity.q4_entity_id}
                />
              </Grid>
            </Grid>
          </div>
          <div className='target-detail_tab-section'>
            <SectionTab
              rememberMounted
              tabs={[
                {
                  id: 'contact',
                  label: 'Contact',
                  view: (
                    <ContactGridOld
                      entityId={entity && entity.entityId}
                      entityType={ENTITY_FUND}
                      handleRowClick={({ contactId }) => {
                        handleRedirect({ contactId, entityType: FLYOUT_ENTITY_TYPES.CONTACT })
                      }}
                    />
                  )
                },
                {
                  id: 'activity',
                  label: 'Activity',
                  view: (
                    <ActivityGridOld
                      isEntity
                      entityType={ENTITY_FUND}
                      entityId={entity._id}
                      entity={entity}
                      handleExpandMenuItemClick={handleRedirect}
                      showChildren
                    />
                  )
                },
                {
                  id: 'holdings',
                  label: 'Holdings',
                  view: (
                    <HoldingGrid
                      entityId={entity && entity.entityId}
                      entityType={ENTITY_FUND}
                    />
                  )
                }
              ]}
            />
          </div>
        </div>
      )
  )
}

export default Fund
